import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'search-suggestion-click';
/**
 * This is the search suggestion click event

1. Container name and 0-indexed container position (separated by |)
2. Request ID
3. Query, suggestion, and 0-indexed position of suggestion within container (separated by |)
*/
export function trackSearchSuggestionClick(customParameterToken, customParameterToken2, customParameterToken3) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            customParameterToken,
            customParameterToken2,
            customParameterToken3,
        },
    });
}
